/**
 * @voltxampere/ui — 9V battery clip (Sprint 50-8)
 *
 * Standard 9V "PP3" battery snap connector with red/black lead
 * wires. Connects to 9V transistor batteries (NEDA 1604) commonly
 * used in guitar effects pedals, smoke detectors, multimeters.
 *
 * Modeled as a 9V voltage source with internal resistance ~1Ω
 * (representing battery ESR).
 *
 * Engine zero-diff invariant honored — schemaType `voltage-source`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const connector9vClip = {
    id: "battery-9v-clip",
    nameTr: "9V Pil Klipsi (PP3 Snap)",
    nameEn: "9V Battery Clip (PP3 Snap)",
    shortcut: "B",
    category: "source",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "BAT",
    defaultValue: "9V",
    schemaType: "voltage-source",
    defaultParams: {
        voltage: 9,
        busType: "battery-clip",
        standard: "PP3 / NEDA 1604",
        internalResistanceOhm: 1,
        typicalCapacityMah: 565,
    },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=connector-9v-clip.js.map